const isIdValue = _.memoize(
  (val = '') => _.size(val) === 12 && val[2] === '-' && val[7] === '-',
)

const $isIdValue = (val) => (_.isString(val) ? isIdValue(val) : false)

export default $isIdValue
